import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, select, takeLatest } from "redux-saga/effects"
import { handleError } from "app/redux/errorHandler/errorHandler.saga"
import * as actions from "./practice.actions"
import * as functionsActions from "../functions/functions.actions"
import * as selectors from "./practice.selectors"
import { setDocumentTitle } from "../utils"
import * as notificationActions from "../notifications/notifications.actions"

export function* getPracticeFlow(): SagaIterator {
  try {
    const response = yield call(api.getPractice)
    const practiceName = response?.data?.name

    yield call(setDocumentTitle, practiceName)
    yield put(actions.getPracticeSuccess(response && response.data))
    yield put(functionsActions.getFunctions())
  } catch (e) {
    yield put(actions.getPracticeFail(e))
    yield call(handleError, { error: e })
  }
}

export function* putPracticeFlow(action: actions.PutPracticeAction): SagaIterator {
  try {
    const { field, value } = action.payload.data
    const practice = yield select(selectors.getPractice)
    practice[field] = value
    yield call(api.putPractice, practice)
    yield put(actions.getPractice())
    yield put(actions.putPracticeSuccess())
  } catch (e) {
    yield put(actions.putPracticeFail(e))
    yield call(handleError, { error: e })
  }
}

export function* putPracticeFeaturesFlow(action: actions.PutPracticeFeaturesAction): SagaIterator {
  try {
    const { data: features } = action.payload
    const { data } = yield call(api.putPracticeFeatures, features)
    yield put(actions.putPracticeFeaturesSuccess(data))
    yield put(
      notificationActions.show({
        id: "putPracticeFeatures",
        message: "confirmationdialog.practice.features.update",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.putPracticeFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* practiceSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getPracticeFlow)
  yield takeLatest(actions.Types.PUT, putPracticeFlow)
  yield takeLatest(actions.Types.PUT_FEATURES, putPracticeFeaturesFlow)
}
